import React from 'react';
import { MenuItem, TextField } from '@mui/material';

import { AgenticPersonality } from '../../../../store/modules/merchant/types';

export const ALL_AGENTS_VIEW = 'all';

type AgentViewSelectProps = {
  value: string;
  personalities: AgenticPersonality[];
  onChange: (next: string) => void;
  disabled?: boolean;
};

export const AgentViewSelect = ({
  value,
  personalities,
  onChange,
  disabled,
}: AgentViewSelectProps) => (
  <TextField
    select
    label="View"
    value={value}
    onChange={(event) => onChange(event.target.value)}
    disabled={disabled}
    sx={{ width: '100%', maxWidth: 413 }}
    data-testid="ella-agent-view-select"
  >
    <MenuItem value={ALL_AGENTS_VIEW}>All agents</MenuItem>
    {personalities
      .filter((personality) => Boolean(personality.personalityId))
      .map((personality) => (
        <MenuItem key={personality.personalityId} value={personality.personalityId}>
          {personality.displayName || 'Untitled agent'}
        </MenuItem>
      ))}
  </TextField>
);
